import { ErrorMessage, useField, useFormikContext } from "formik";
import { forwardRef, useState } from "react";
import { Form, Badge } from "react-bootstrap";
import InputMask from "react-input-mask";


const EditCpfCnpjControl = forwardRef((props, ref) => {
    const { name, placeholder, hideTitle, value, onChange, tipoPessoa, disabled } = props;

    const { handleChange, validateOnMount } = useFormikContext();
    const [fieldId, metaId, handleId] = useField(name);

    // const [stateTipoPessoa, setStateTipoPessoa] = useState(tipoPessoa);

    return (
        <Form.Group>
            {!hideTitle && <Form.Label className="mb-0">{placeholder}</Form.Label>}

            <InputMask
                {...props}
                disabled={disabled}
                ref={ref}
                name={name}
                value={value ? value : metaId.value}
                onChange={(e) => {
                    handleChange(e)
                    onChange && onChange(e);
                }}
                onWheel={(e) => e.target.blur()}
                mask={tipoPessoa === 'Física' ? "999.999.999-99" : "**.***.***/****-99"}
            >
                {(inputProps) => <Form.Control {...inputProps} disabled={disabled} placeholder="" />}
            </InputMask>

            {validateOnMount && metaId.error && <Badge bg="danger">{metaId.error}</Badge>}

            {
                !validateOnMount && <ErrorMessage name={props.name}>
                    {(msg) => <Badge bg="danger">{msg}</Badge>}
                </ErrorMessage>
            }

        </Form.Group >
    );
});

export default EditCpfCnpjControl;

